import { useEffect } from "react";
import Mousetrap from "mousetrap";

export default function Key(props) {
  useEffect(() => {
    Mousetrap.bind("esc", props.esc);
    Mousetrap.bind("up", props.up);
    Mousetrap.bind("down", props.down);

    Mousetrap.bind("+", props.buy);
    Mousetrap.bind("=", props.buy);
    Mousetrap.bind("-", props.sell);

    Mousetrap.bind("shift+1", props.one);
    Mousetrap.bind("shift+2", props.two);
    Mousetrap.bind("shift+3", props.three);
    Mousetrap.bind("shift+4", props.four);
    Mousetrap.bind("shift+5", props.five);

    return () => {
      Mousetrap.unbind("esc");
      Mousetrap.unbind("up");
      Mousetrap.unbind("down");

      Mousetrap.unbind("+");
      Mousetrap.unbind("=");
      Mousetrap.unbind("-");

      Mousetrap.unbind("shift+1");
      Mousetrap.unbind("shift+2");
      Mousetrap.unbind("shift+3");
      Mousetrap.unbind("shift+4");
      Mousetrap.unbind("shift+5");
    };
  }, [
    props.esc,
    props.up,
    props.down,
    props.buy,
    props.sell,
    props.one,
    props.two,
    props.three,
    props.four,
    props.five,
  ]);

  return null;
}
